import SharedSortableTableController from "../../shared/sortable_table_controller";

// Connects to data-controller="administration--pages--sortable-table"
export default class extends SharedSortableTableController {
  getColumnIndex(attribute) {
    const attributeToIndexMap = {
      link: 0,
      name: 1,
      author: 2,
      created_at: 3,
    };

    return attributeToIndexMap[attribute] || 0;
  }
}
